export const formatCurrency = function <T>(n?: T) {
  if (typeof n !== 'number' || n === 0) {
    return '\u2500';
  }

  return `$${n.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`;
};

const padZero = function (x: number) {
  return `${'00'.slice(x.toFixed(0).length)}${x}`;
};

export function formatDate(str?: string, dateOnly = false) {
  if (!str) {
    return '';
  }

  const d: Date = new Date(str);
  const currentDate: Date = new Date();
  const diff: number = d.valueOf() - currentDate.valueOf();
  const inSecs = diff / 1000,
    inMins = inSecs / 60,
    mins = inMins % 60,
    hours = inMins / 60,
    hourStr = hours >= 1 ? `${Math.floor(hours)}h ` : '',
    soonStr = `${hourStr}${Math.floor(mins)}m`,
    dateStr = `${padZero(d.getMonth() + 1)}/${padZero(d.getDate())}/${(d.getFullYear() + '').slice(
      2,
    )}`,
    finalStr = hours >= 24 || dateOnly ? dateStr : soonStr;

  return diff > 0 || dateOnly ? finalStr : '\u2500';
}

export function getCellValue<T>(item: { [key: string]: T }, field: string) {
  let val = item[field],
    value;

  switch (field) {
    case 'end_time':
      value = item['active'] ? formatDate(`${val}`) : '\u2500';
      break;
    case 'lead_bid':
    case 'your_bid':
    case 'next_bid':
      value = formatCurrency(val);
      break;
    case 'addl':
      value = val && val !== null ? 'Yes' : 'No';
      break;
    case 'item_type':
      value = val || item?.['stone_type'];
      break;
    default:
      value =
        val && typeof val === 'string' && val.trim() !== ''
          ? val
          : typeof val === 'object'
          ? val
          : '\u2500';
      break;
  }

  return value;
}

export function isAuctionHasProperties(auction: any) {
  return (
    auction?.diamond_type === 'Natural' ||
    auction?.diamond_type === 'Lab Grown' ||
    auction?.gemstone_type ||
    auction?.brand
  );
}

export function getSortedProviderAndNumber(items: {
  [key: number | string]: { number?: string | null; provider: string };
}) {
  if (!items || Object.keys(items).length === 0) {
    return;
  }

  let certificates = Object.values(items) as Array<{ number?: string | null; provider: string }>;

  if (certificates?.length > 0) {
    const giaCertificates: Array<{ number?: string | null; provider: string }> = [],
      restCertificates: Array<{ number?: string | null; provider: string }> = [],
      otherCertificates: Array<{ number?: string | null; provider: string }> = [];

    for (const item of certificates) {
      if (item.provider) {
        if (
          item.provider.toLowerCase().search('gia') > -1 ||
          (item?.number && item?.number !== null && item?.number.toLowerCase().search('gia') > -1)
        ) {
          giaCertificates.push(item);
        } else if (item.provider.toLowerCase().search('other') > -1) {
          otherCertificates.push(item);
        } else {
          restCertificates.push(item);
        }
      }
    }

    certificates = [...giaCertificates, ...restCertificates, ...otherCertificates];
    return certificates[0];
  }

  return;
}

export function roundUp(val: any) {
  if (typeof val === 'number') {
    return Math.ceil(val);
  }
  return val;
}

export function cutStringToSpace(str?: string, length?: number) {
  if (typeof str !== 'string' || typeof length !== 'number') {
    return str;
  }

  if (str.length > length) {
    return str.slice(0, str.search(' '));
  }

  return str;
}
